import {
  TOGGLE_WARNINGS_ON_MAP,
  OPEN_MORE_OPTIONS,
  CLOSE_MORE_OPTIONS,
  SET_VIEW_STATE,
  SET_LAYER_STYLE,
  SET_DRAFT,
  SET_VIEW_LOCK,
} from '../actions/constants';

export const defaultState = {
  showLowestWarnings: true,
  showMoreOptions: false,
  viewState: {
    latitude: 52.368,
    longitude: 4.9036,
    zoom: 8,
    width: 500,
    height: 300,
  },
  layerStyle: 'water_depth',
  draft: 2,
  viewLock: true,
};

export const desktopMapReducer = (state = defaultState, action) => {
  switch (action.type) {
    case TOGGLE_WARNINGS_ON_MAP: {
      return {
        ...state,
        showLowestWarnings: !state.showLowestWarnings,
      };
    }
    case OPEN_MORE_OPTIONS: {
      return {
        ...state,
        showMoreOptions: true,
      };
    }
    case CLOSE_MORE_OPTIONS: {
      return {
        ...state,
        showMoreOptions: false,
      };
    }
    case SET_VIEW_STATE: {
      return {
        ...state,
        viewState: action.viewState,
      };
    }
    case SET_LAYER_STYLE: {
      return {
        ...state,
        layerStyle: action.layerStyle,
      };
    }
    case SET_DRAFT: {
      return {
        ...state,
        draft: action.draft,
      };
    }
    case SET_VIEW_LOCK: {
      return {
        ...state,
        viewLock: action.viewLock,
      };
    }
    default:
      return state;
  }
};
